import React from 'react';
import animationData from 'assets/animations/brokenlink.json';
import Lottie from 'react-lottie';
import {
  Avatar,
  Box,
  Button,
  Container,
  CssBaseline,
  makeStyles,
  Paper,
  Link,
  Typography,
} from '@material-ui/core';
import NavigationService from 'services/NavigationService';
import Logo from 'assets/images/khula-logo-badge-green.svg';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: theme.spacing(4),
    paddingTop: theme.spacing(0),
  },
  avatar: {
    width: 128,
    height: 128,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function TokenExpiredScreen() {
  const classes = useStyles();

  const animationOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const handleSignIn = (e: any) => {
    e.preventDefault(); // prevent http post on submit
    NavigationService.navigate('/login');
  };

  return (
    <Container className="login-container" component="main" maxWidth="xs">
      <CssBaseline />
      <Paper className={classes.paper} variant="outlined">
        <Avatar className={classes.avatar} src={Logo} variant="square" />
        <Box mb={4} mt={-1}>
          <Typography component="h1" variant="subtitle1">
            Supplier Dashboard
          </Typography>
        </Box>
        <Typography component="h1" variant="h5">
          Your token has expired
        </Typography>
        <Box mt={6}>
          <Lottie options={animationOptions} height={160} width={160} />
        </Box>
        <form className={classes.form} noValidate onSubmit={handleSignIn}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            type="submit"
          >
            Sign In
          </Button>
        </form>
      </Paper>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://khula.co.za/">
        Khula!
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
